@let appConfiguration = this.appConfiguration();
@let loggedIn = this.loggedIn();

@if (appConfiguration) {
    <div (click)="onCountryMenuSelectionClick()">
        <div class="heading">
            <span>{{ 'COUNTRY_SELECTION.CURRENT' | translate }}</span>
        </div>
        <div class="menu">
            <div>
                <span>{{ 'COUNTRY.' + (appConfiguration.country | countryISO: appConfiguration) | translate }}</span>
            </div>
            @if (!loggedIn) {
                <div class="change">
                    <span class="change-text">{{ 'COUNTRY_SELECTION.CHANGE' | translate }}</span>
                    <warema-icon icon="beakRight" />
                </div>
            }
        </div>
    </div>
}
